import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 520.000000 520.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
       
<g transform="translate(0.000000,520.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2370 2800 c0 -5 -8 -10 -17 -10 -17 0 -83 -40 -83 -50 0 -3 13 -21
28 -39 l28 -34 47 36 c47 36 142 77 177 77 11 0 20 7 20 15 0 12 -18 15 -100
15 -60 0 -100 -4 -100 -10z"/>
<path d="M2625 2798 c3 -7 27 -18 53 -25 63 -15 134 -49 168 -80 l26 -24 29
27 c16 15 29 34 29 41 0 16 -58 53 -82 53 -10 0 -18 4 -18 9 0 5 -47 9 -105
10 -83 2 -104 -1 -100 -11z"/>
<path d="M2482 2692 c-24 -9 -58 -29 -75 -43 l-32 -27 34 -36 c31 -32 37 -34
51 -21 26 23 103 55 136 55 41 0 116 -26 141 -50 20 -18 21 -18 57 19 l36 37
-27 20 c-16 12 -50 31 -77 42 -60 27 -179 29 -244 4z"/>
<path d="M2312 2540 c-44 -72 -48 -211 -7 -289 22 -43 19 -51 -18 -51 -21 0
-41 -8 -52 -20 -18 -20 -17 -20 60 -20 76 0 78 1 112 36 31 33 32 38 19 53
-42 47 -59 152 -35 221 11 30 9 34 -24 68 l-35 35 -20 -33z"/>
<path d="M2831 2536 c-29 -30 -32 -36 -21 -57 7 -12 13 -50 13 -83 1 -58 -8
-88 -43 -143 -13 -21 -12 -25 20 -58 33 -34 36 -35 109 -35 73 0 74 0 56 20
-11 13 -31 20 -53 20 -29 0 -33 3 -27 18 37 83 47 130 42 193 -5 59 -41 159
-57 159 -3 0 -21 -15 -39 -34z"/>
<path d="M2526 2459 c-36 -43 -36 -106 0 -142 54 -55 141 -40 170 29 18 42 10
80 -24 117 -21 22 -34 27 -73 27 -40 0 -51 -4 -73 -31z"/>
<path d="M902 1808 c-16 -40 -49 -119 -72 -176 -26 -62 -53 -111 -68 -122
l-25 -20 64 1 c35 1 54 4 41 6 -30 6 -36 24 -22 68 l12 35 64 0 c65 0 65 0 80
-35 20 -48 18 -63 -8 -68 -13 -2 17 -5 67 -6 81 -1 88 0 68 14 -13 9 -47 81
-93 195 -40 99 -73 180 -75 180 -2 0 -17 -33 -33 -72z m17 -100 c38 -90 39
-88 -18 -88 -28 0 -51 3 -51 7 0 10 44 123 48 123 1 0 11 -19 21 -42z"/>
<path d="M1160 1860 c18 -18 20 -33 20 -175 0 -142 -2 -157 -20 -175 l-20 -20
73 0 c54 1 68 3 55 11 -16 9 -18 29 -18 194 l0 185 -55 0 -55 0 20 -20z"/>
<path d="M2478 1864 c19 -13 22 -24 22 -75 0 -54 -10 -74 -25 -49 -8 13 -51
13 -76 0 -30 -17 -49 -64 -49 -127 0 -101 57 -157 122 -120 25 14 28 14 28 1
0 -10 6 -14 18 -10 9 2 32 8 51 11 28 6 31 9 18 17 -15 8 -17 31 -17 188 l0
180 -57 0 c-55 0 -56 -1 -35 -16z m4 -151 c28 -25 26 -162 -2 -188 -20 -18
-22 -18 -38 -1 -13 13 -17 34 -17 94 0 110 14 134 57 95z"/>
<path d="M2073 1859 c15 -9 17 -29 17 -195 l0 -184 25 16 c22 14 26 14 47 0
28 -20 41 -20 84 0 105 50 86 254 -22 254 -18 0 -36 -4 -39 -10 -16 -26 -25
-4 -25 60 l0 70 -52 0 c-41 -1 -49 -3 -35 -11z m157 -165 c11 -28 12 -116 1
-153 -3 -13 -14 -29 -24 -35 -15 -9 -21 -7 -33 8 -18 25 -20 176 -2 194 20 20
48 14 58 -14z"/>
<path d="M3002 1844 c-1 -7 -22 -34 -47 -62 -49 -54 -53 -62 -30 -62 12 0 15
-18 15 -103 0 -88 3 -106 18 -120 27 -25 65 -21 93 9 24 26 24 27 1 15 -12 -7
-27 -9 -32 -6 -6 3 -10 51 -10 106 l0 99 30 0 c20 0 30 5 30 15 0 10 -10 15
-29 15 -29 0 -30 2 -34 53 -2 28 -4 47 -5 41z"/>
<path d="M1364 1740 c-24 -9 -54 -47 -54 -68 0 -15 39 -32 59 -24 9 3 11 15 8
38 -5 26 -2 36 13 44 29 15 49 2 56 -38 6 -29 3 -38 -11 -47 -117 -70 -138
-94 -117 -140 14 -31 52 -33 97 -5 l33 20 5 -20 c6 -24 53 -28 81 -7 17 12 17
14 2 20 -13 5 -16 23 -16 101 0 90 -1 95 -26 115 -28 22 -90 27 -130 11z m86
-159 c0 -45 -22 -71 -48 -54 -25 15 -25 36 -2 66 31 40 50 35 50 -12z"/>
<path d="M1583 1739 c14 -9 17 -26 17 -119 0 -93 -3 -110 -17 -119 -14 -8 0
-10 55 -11 l72 0 -21 21 c-18 18 -21 30 -17 95 4 77 18 108 40 86 7 -7 18 -12
25 -12 17 0 34 35 27 54 -9 23 -51 20 -66 -4 -7 -11 -16 -20 -20 -20 -5 0 -8
9 -8 20 0 17 -7 20 -52 20 -41 -1 -49 -3 -35 -11z"/>
<path d="M1845 1738 c-47 -25 -59 -70 -24 -89 17 -9 25 -8 37 5 13 12 13 20 4
41 -11 23 -9 27 13 37 34 15 55 -4 55 -51 0 -34 -4 -38 -57 -67 -68 -36 -92
-77 -67 -113 19 -27 63 -28 96 -2 24 19 24 19 36 0 17 -26 64 -25 88 3 10 12
13 18 5 13 -23 -13 -31 15 -31 112 0 84 -2 93 -22 107 -26 18 -103 21 -133 4z
m73 -210 c-47 -30 -65 37 -21 78 l28 26 3 -47 c2 -32 -1 -51 -10 -57z"/>
<path d="M2671 1724 c-35 -29 -40 -59 -12 -74 35 -18 53 -2 46 40 -6 33 -4 39
15 45 30 10 50 -12 50 -55 0 -33 -4 -39 -32 -51 -52 -21 -98 -68 -98 -98 0
-15 5 -32 12 -39 18 -18 62 -14 91 8 l26 21 11 -21 c13 -24 62 -27 80 -5 7 9
8 15 2 15 -6 0 -12 41 -14 101 -3 92 -5 103 -27 120 -36 29 -111 26 -150 -7z
m87 -196 c-46 -29 -63 30 -21 74 l28 30 3 -48 c2 -31 -1 -50 -10 -56z"/>
<path d="M3143 1730 c-41 -25 -47 -74 -11 -84 32 -8 53 15 39 42 -15 28 -14
30 9 42 34 18 62 -4 58 -48 -3 -33 -9 -40 -58 -67 -64 -36 -88 -74 -71 -111
13 -30 53 -32 97 -5 30 18 31 18 42 0 14 -22 50 -25 76 -6 17 12 17 14 2 20
-13 5 -16 23 -16 102 0 82 -3 98 -20 115 -27 27 -103 27 -147 0z m97 -149 c0
-42 -3 -51 -22 -57 -26 -8 -48 17 -41 47 5 16 47 59 59 59 2 0 4 -22 4 -49z"/>
<path d="M3572 1716 c-36 -34 -37 -36 -37 -106 0 -68 2 -73 33 -101 46 -41
100 -40 144 2 23 21 26 27 11 20 -67 -33 -123 18 -125 112 -1 55 8 83 29 91
21 9 39 -9 47 -45 5 -26 10 -30 33 -27 39 4 43 39 7 67 -42 33 -96 28 -142
-13z"/>
<path d="M3843 1740 c-41 -17 -65 -68 -60 -133 3 -49 8 -63 35 -90 62 -61 161
-36 191 49 30 86 -26 185 -105 183 -22 0 -49 -4 -61 -9z m79 -17 c15 -13 18
-31 18 -100 0 -91 -10 -123 -39 -123 -28 0 -42 23 -48 83 -7 66 2 121 23 142
19 19 23 19 46 -2z"/>
<path d="M4058 1738 c16 -16 16 -220 0 -236 -9 -9 2 -12 52 -12 50 0 61 3 52
12 -8 8 -12 46 -12 105 0 91 1 94 26 105 36 17 44 0 44 -104 0 -66 -4 -90 -16
-102 -14 -15 -10 -16 47 -16 49 0 60 3 51 12 -7 7 -12 45 -12 98 0 74 3 90 20
105 10 9 26 15 35 12 12 -5 15 -26 15 -111 0 -74 -4 -106 -12 -109 -7 -3 16
-5 52 -5 36 0 59 2 53 5 -9 3 -13 30 -13 86 0 88 -12 146 -32 159 -23 14 -65
8 -92 -13 l-27 -22 -15 22 c-18 25 -69 28 -102 5 -20 -14 -22 -14 -22 0 0 13
-12 16 -52 16 -40 0 -49 -3 -40 -12z"/>
<path d="M3406 1554 c-9 -8 -16 -22 -16 -29 0 -18 27 -45 45 -45 16 0 45 27
45 41 0 43 -45 63 -74 33z"/>
</g>
</svg>







    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
